export const StarStrikethrought: React.FC<React.ComponentProps<"svg">> = ({
  ...props
}) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.5036 3.51275C36.7725 3.79042 36.7655 4.23358 36.4878 4.50257L4.48784 35.5026C4.21017 35.7716 3.76701 35.7645 3.49801 35.4869C3.22902 35.2092 3.23605 34.766 3.51373 34.497L35.5137 3.49704C35.7914 3.22804 36.2346 3.23508 36.5036 3.51275Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.1392 11.5982L21.9345 5.01541C21.5739 4.27473 20.826 3.7998 20.0008 3.7998C19.1755 3.7998 18.4277 4.27473 18.0671 5.01541L14.0723 13.2212L5.14237 14.5446C4.3265 14.6655 3.65574 15.2441 3.405 16.0282C3.15455 16.8113 3.36312 17.6726 3.94861 18.2508L10.4142 24.636L10.166 26.1035L11.8619 24.4605C11.882 24.2519 11.8074 24.0442 11.657 23.8957L4.93234 17.2547C4.72476 17.0497 4.64745 16.7392 4.73847 16.4546C4.82918 16.171 5.06804 15.9709 5.34761 15.9294L14.6427 14.5519C14.8712 14.5181 15.0683 14.3736 15.1694 14.1659L19.3259 5.62822C19.4554 5.3622 19.7188 5.1998 20.0008 5.1998C20.2828 5.1998 20.5462 5.3622 20.6757 5.62822L24.0811 12.6232L25.1392 11.5982ZM29.0263 13.6801L27.7592 14.9076L34.6539 15.9294C34.9335 15.9709 35.1724 16.171 35.2631 16.4546C35.3541 16.7392 35.2768 17.0497 35.0692 17.2547L28.3446 23.8957C28.1822 24.056 28.1082 24.2855 28.1462 24.5105L29.7333 33.8925C29.7833 34.1881 29.6625 34.483 29.4296 34.6546C29.1982 34.825 28.8938 34.8468 28.6422 34.7126L20.3301 30.2806C20.1243 30.1708 19.8773 30.1708 19.6714 30.2806L11.3594 34.7126C11.1077 34.8468 10.8034 34.825 10.572 34.6546C10.3391 34.483 10.2183 34.1881 10.2683 33.8925L10.6811 31.4521L8.98294 33.0972L8.88791 33.659C8.75072 34.4699 9.07864 35.2934 9.74169 35.7818C10.4062 36.2713 11.2896 36.3364 12.0181 35.948L20.0008 31.6915L27.9835 35.948C28.712 36.3364 29.5953 36.2713 30.2599 35.7818C30.9229 35.2934 31.2508 34.4699 31.1136 33.659L29.5873 24.636L36.0529 18.2508C36.6384 17.6726 36.847 16.8113 36.5966 16.0282C36.3458 15.2441 35.6751 14.6655 34.8592 14.5446L29.0263 13.6801Z"
        fill="currentColor"
      />
    </svg>
  );
};
